import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api/message';
import { environment } from 'src/environments/environment';
import { SessionApiService } from '../services/auth/session-api.service';
import { PASSWORD_HINT, strongPassword } from './password-rules';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../login/login.component.scss'],
})
export class ResetPasswordComponent {
  environment = environment;
  passwordHint = PASSWORD_HINT;
  msgs: Message[] = [];
  loading = false;
  done = false;

  /** Il token resta solo in memoria: viene tolto dall'indirizzo appena letto. */
  private token = '';

  frm = new FormGroup({
    newPassword: new FormControl('', [Validators.required, strongPassword]),
    confirmNewPassword: new FormControl('', [Validators.required]),
  });

  constructor(
    private sessionApi: SessionApiService,
    private route: ActivatedRoute,
    private router: Router,
    private title: Title
  ) {
    this.title.setTitle(`${environment.softwareName} - Nuova password`);
  }

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (this.token) {
      this.router.navigate([], { queryParams: { token: null }, replaceUrl: true });
    }
  }

  get hasToken() {
    return !!this.token;
  }

  get mismatch() {
    const { newPassword, confirmNewPassword } = this.frm.value;
    return !!confirmNewPassword && newPassword !== confirmNewPassword;
  }

  submit() {
    if (this.frm.invalid || this.mismatch || this.loading || !this.token) return;
    this.loading = true;
    this.msgs = [];
    this.sessionApi
      .resetPassword({
        token: this.token,
        newPassword: this.frm.get('newPassword')!.value!,
        confirmNewPassword: this.frm.get('confirmNewPassword')!.value!,
      })
      .subscribe({
        next: () => {
          this.loading = false;
          this.done = true;
          this.token = '';
        },
        error: (error: HttpErrorResponse) => {
          this.loading = false;
          const message = error.error?.message;
          const detail = Array.isArray(message) ? message.join(' ') : message;
          this.msgs = [
            {
              severity: 'error',
              summary: 'Attenzione',
              detail:
                error.status === 0
                  ? 'Impossibile contattare il server. Controlla la connessione.'
                  : typeof detail === 'string' && detail
                    ? detail
                    : 'Non è stato possibile aggiornare la password, riprova.',
            },
          ];
        },
      });
  }
}
